module.exports = __webpack_public_path__ + "static/media/intro.aad64af9.mp3";